import React from "react";

export default function Side() {
    return <div>Side</div>;
}
